<template>
  <div>
    <DisclaimerCard
      :iconSrc="require('@/assets/hammer.svg')"
      :title="$t('message.insurance.disclaimer.firstCardTitle')"
      :text="$t('message.insurance.disclaimer.firstCardText')"
      :paddingTop="false"
      class="px-0"
    ></DisclaimerCard>
    <DisclaimerCard
      :iconSrc="require('@/assets/star.svg')"
      :title="$t('message.insurance.disclaimer.secondCardTitle')"
      :text="`${businessName} ${$t('message.insurance.disclaimer.secondCardText')}`"
    ></DisclaimerCard>
    <DisclaimerCard
      class="mb-4"
      :iconSrc="require('@/assets/eye.svg')"
      :title="$t('message.insurance.disclaimer.thirdCardTitle')"
    ></DisclaimerCard>
    <MobialisButton data-cy="submit" @click="getStart" class="start-button mt-3">{{
      $t('message.common.getStarted')
    }}</MobialisButton>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DisclaimerCard from '@/components/DisclaimerCard.vue';

export default {
  name: 'Disclaimer',
  components: {
    DisclaimerCard,
  },
  mounted() {
    this.$store.commit('SET_LOADING', false);
  },
  computed: {
    ...mapGetters('business', ['getBankStrips', 'getBusinessName']),
    businessName() {
      return this.getBusinessName;
    },
  },
  methods: {
    ...mapActions(['toggleIsLoading']),
    getStart() {
      this.$router.push({
        name: `insurance-personal-form-${this.baseRoute}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
